// extracted by mini-css-extract-plugin
export var fil = "styles-module--fil--P+4PV";
export var productAnim = "styles-module--product-anim--AVlb2";